var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TicketList',{attrs:{"ticket":_vm.ticket,"title":"Due Tickets"}})
}
var staticRenderFns = []

export { render, staticRenderFns }